<template>
  <div class="customer-search">
    <div class="customer-search-form">
      <el-form
        :inline="true"
        :model="form"
        ref="form"
        class="demo-form-inline"
        size="small"
      >
        <el-form-item
          label="客户名称:"
          prop="contact_name"
        >
          <el-input
            v-model="form.contact_name"
            placeholder="客户名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="证件号码:"
          prop="contact_card_number"
        >
          <el-input
            v-model="form.contact_card_number"
            placeholder="证件号码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号码:"
          prop="contact_phone"
        >
          <el-input
            v-model="form.contact_phone"
            placeholder="手机号码"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="resetForm('form')">重置</el-button>
          <el-button
            type="primary"
            @click="onSearch"
          >查询</el-button>
        </el-form-item>
      </el-form>
      <el-button
        type="danger"
        size="small"
        @click="onLogout"
      >退出登录</el-button>
    </div>
    <div class="customer-search-mian">

      <div
        class="customer-search-empty"
        v-if="tableData.length === 0"
      >
        <van-empty
          image="error"
          description="客户不存在"
        />
      </div>
      <div
        class="customer-search-list"
        v-else
      >
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            width="50"
          >
          </el-table-column>
          <el-table-column
            prop="user_mobile"
            label="手机号"
          >
          </el-table-column>
          <el-table-column
            prop="user_cardno"
            label="卡号"
          >
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="姓名"
          >
          </el-table-column>
          <el-table-column
            prop="idCardName"
            label="证件类型"
          >
          </el-table-column>
          <el-table-column
            prop="identification_number"
            label="证件号"
          >
          </el-table-column>
          <el-table-column
            prop="user_sex_displayname"
            label="性别"
            width="100"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="goDetail(scope.row)"
                type="primary"
                size="small"
              >
                确认
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</template>


<script>
import hisService from "@/apis/his/index";
import { Message, Loading } from "element-ui";

const idCardDict = {
  1: "身份证",
  2: "工作证",
  3: "学生证",
  4: "军官证",
  5: "暂住证",
  6: "低保证",
  7: "医保手册",
  8: "驾照",
  9: "户口本",
  10: "士兵证",
  11: "回乡证",
  12: "临时身份证",
  13: "警官证",
  14: "外国人永久居留证",
  17: "海员证",
  18: "港澳居民来往内地通行证",
  19: "台胞证",
  97: "护照",
  98: "出生证明",
  99: "其他",
};
let loadingInstance = null;
export default {
  data() {
    return {
      form: {
        contact_phone: "",
      },
      tableData: [],
    };
  },
  watch: {
    $route() {
      if (this.$route.query.mobile) {
        this.form.contact_phone = `${this.$route.query.mobile}`;
        this.onSearch();
      }
    },
  },
  created() {
    if (this.$route.query.mobile) {
      this.form.contact_phone = `${this.$route.query.mobile}`;
      this.onSearch();
    }
  },
  methods: {
    onSearch() {
      const { form } = this;
      if (
        !form.contact_phone &&
        !form.contact_card_number &&
        !form.contact_name
      ) {
        Message({
          message: "请输入客户信息",
          type: "error",
        });
        return;
      }

      const query = {
        ...form,
      };

      const params = {
        msg_type: "OutpatientDepartment.BaesInfoCore.FindUserInfo",
        logistics_interface: JSON.stringify(query),
      };
      loadingInstance = Loading.service({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      hisService
        .mainMethod(params)
        .then((res) => {
          loadingInstance.close();
          res.forEach((item) => {
            item.idCardName = idCardDict[item.document_type];
          });
          if (res.length === 1) {
            this.goDetail(res[0]);
          }
          this.tableData = res;
        })
        .catch(() => {
          loadingInstance.close();
        });
    },
    goDetail(item) {
      this.$router.push({
        name: "CustomerDetail",
        query: {
          patientId: item.patientId,
        },
      });
    },

    resetForm(formName) {
      this.form = {};
      this.$refs[formName].resetFields();
    },
    onLogout() {
      this.$store.dispatch("user/logout");
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-search {
  height: 100vh;
  padding: 20px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.customer-search-form {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-button--danger {
    margin-bottom: 15px;
  }
}
.customer-search-mian {
  flex: 1;
  overflow-y: auto;
}
.customer-search-list {
  height: 100%;
}
</style>